var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateSellout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_50918)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.709 44.9937C105.573 34.5922 90.1212 36.5778 76.539 36.5778C63.2138 36.5778 73.3831 -0.0510403 56.3759 5.34035e-05C41.8128 0.0438815 49.4302 21.7046 26.1577 25.1382C4.76724 28.294 -4.21683 41.0197 2.3738 51.3057C8.51888 60.8961 26.9471 57.8808 29.4043 69.0436C33.5283 87.7777 12.9861 107.057 28.6004 117.17C49.538 130.731 63.2349 91.2748 89.502 89.019C115.794 86.7605 127.972 63.2281 113.709 44.9937Z",
    fill: "url(#paint0_linear_2041_50918)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2041_50918",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 102,
    height: 102
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.75002H110.25V111H9V9.75002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2041_50918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.767 43.2948V98.8755H34.03C32.7782 98.8755 31.7657 97.861 31.7657 96.6112V35.6378C31.7657 34.386 32.7782 33.3735 34.03 33.3735H61.4901C62.0893 33.3735 62.6648 33.6108 63.09 34.0359L69.422 40.368C69.8472 40.7932 70.4227 41.0305 71.0239 41.0305H106.503C107.753 41.0305 108.767 42.045 108.767 43.2948Z",
    fill: "#FFF2AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3405 54.486C34.3405 56.3587 33.3003 57.9882 31.7657 58.8267V50.1453C33.3003 50.9837 34.3405 52.6132 34.3405 54.486Z",
    fill: "#FFE86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2091 39.2166C66.2091 41.9496 63.9935 44.165 61.2607 44.165C58.5276 44.165 56.3121 41.9496 56.3121 39.2166C56.3121 36.4837 58.5276 34.2682 61.2607 34.2682C63.9935 34.2682 66.2091 36.4837 66.2091 39.2166Z",
    fill: "#FFE86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.767 43.2948V98.8755H101.248V43.2948C101.248 42.045 100.236 41.0305 98.9841 41.0305H106.503C107.753 41.0305 108.767 42.045 108.767 43.2948Z",
    fill: "#FFE86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2891 66.124C75.2891 69.587 72.4816 72.3945 69.0185 72.3945C65.5552 72.3945 62.7479 69.587 62.7479 66.124C62.7479 62.6607 65.5552 59.8534 69.0185 59.8534C72.4816 59.8534 75.2891 62.6607 75.2891 66.124Z",
    fill: "#F599A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2887 66.1228C75.2887 69.5872 72.4804 72.3955 69.0187 72.3955C67.8583 72.3955 66.7692 72.0801 65.838 71.5272C68.2995 70.9598 70.1334 68.7562 70.1334 66.1228C70.1334 63.492 68.3024 61.2857 65.841 60.7181C66.7722 60.168 67.8583 59.8528 69.0187 59.8528C72.4804 59.8528 75.2887 62.6611 75.2887 66.1228Z",
    fill: "#F06677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2891 66.124C75.2891 69.587 72.4816 72.3945 69.0185 72.3945C65.5552 72.3945 62.7479 69.587 62.7479 66.124C62.7479 62.6607 65.5552 59.8534 69.0185 59.8534C72.4816 59.8534 75.2891 62.6607 75.2891 66.124Z",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5264 41.0314H71.0229C70.4223 41.0314 69.8465 40.7929 69.4219 40.3684L63.09 34.0363C62.6654 33.6117 62.0896 33.3732 61.489 33.3732H34.0291C32.7787 33.3732 31.765 34.3869 31.765 35.6373V58.7593",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.767 98.8755V43.2956C108.767 42.0454 107.753 41.0317 106.503 41.0317H87.8488",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.765 66.0819V69.646",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6741 70.4824L108.767 98.8765H32.8416C32.1601 98.8765 31.5151 98.5698 31.0851 98.041L10.9953 73.3395C9.79199 71.8601 10.8448 69.6469 12.7518 69.6469H83.9177C84.5989 69.6469 85.2442 69.9538 85.6741 70.4824Z",
    fill: "#B0CCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.767 98.8755H99.0295L75.9378 70.482C75.5067 69.954 74.862 69.6455 74.1818 69.6455H83.9172C84.5994 69.6455 85.2441 69.954 85.6732 70.482L108.767 98.8755Z",
    fill: "#B0CCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2486 98.8765H108.767L85.6742 70.4824C85.2443 69.9536 84.5993 69.6467 83.9178 69.6467H12.7519C10.845 69.6467 9.79212 71.8599 10.9954 73.3393L31.0853 98.041C31.5152 98.5696 32.1603 98.8765 32.8417 98.8765H71.9264",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7257 68.6074V66.6299",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7257 61.0503V26.6413",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.72 5.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7257 23.8516V21.874H41.7032",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5568 21.874H93.4072",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.9 5.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3339 21.874H98.3114V23.8516",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3114 29.9561V77.7783",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.07 6.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3114 80.8311V82.8086",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2091 34.2684C66.2091 37.0014 63.9935 39.2168 61.2607 39.2168C58.5276 39.2168 56.3121 37.0014 56.3121 34.2684C56.3121 31.5354 58.5276 29.32 61.2607 29.32C63.9935 29.32 66.2091 31.5354 66.2091 34.2684Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.209 34.2681C66.209 37.002 63.9928 39.2183 61.2612 39.2183C60.3454 39.2183 59.486 38.9693 58.7511 38.5328C60.6934 38.0851 62.1408 36.3463 62.1408 34.2681C62.1408 32.1921 60.6958 30.4508 58.7533 30.0031C59.4883 29.5689 60.3454 29.3201 61.2612 29.3201C63.9928 29.3201 66.209 31.5363 66.209 34.2681Z",
    fill: "#B0CCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2091 34.2684C66.2091 37.0014 63.9935 39.2168 61.2607 39.2168C58.5276 39.2168 56.3121 37.0014 56.3121 34.2684C56.3121 31.5354 58.5276 29.32 61.2607 29.32C63.9935 29.32 66.2091 31.5354 66.2091 34.2684Z",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3407 49.995C34.3407 52.7279 32.1253 54.9434 29.3923 54.9434C26.6594 54.9434 24.4437 52.7279 24.4437 49.995C24.4437 47.262 26.6594 45.0466 29.3923 45.0466C32.1253 45.0466 34.3407 47.262 34.3407 49.995Z",
    fill: "#8AB4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3406 49.9944C34.3406 52.7283 32.1244 54.9443 29.3928 54.9443C28.477 54.9443 27.6175 54.6956 26.8827 54.2591C28.8252 53.8114 30.2724 52.0726 30.2724 49.9944C30.2724 47.9183 28.8274 46.1771 26.8849 45.7294C27.6199 45.2951 28.477 45.0464 29.3928 45.0464C32.1244 45.0464 34.3406 47.2626 34.3406 49.9944Z",
    fill: "#005B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3407 49.995C34.3407 52.7279 32.1253 54.9434 29.3923 54.9434C26.6594 54.9434 24.4437 52.7279 24.4437 49.995C24.4437 47.262 26.6594 45.0466 29.3923 45.0466C32.1253 45.0466 34.3407 47.262 34.3407 49.995Z",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3917 48.8701L73.1857 53.0762",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3917 53.0757L73.1857 48.8697",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5207 22.7451L25.3147 26.9512",
    stroke: "#F599A4",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5207 26.9512L25.3147 22.7451",
    stroke: "#F06677",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5722 92.2163H71.5955C70.9779 92.2163 70.3959 91.928 70.0218 91.4364L64.9023 84.7096C64.4068 84.0586 64.8711 83.122 65.689 83.122H85.6659C86.2833 83.122 86.8655 83.4105 87.2394 83.9019L92.3591 90.6287C92.8545 91.2797 92.3903 92.2163 91.5722 92.2163Z",
    fill: "#CCDDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5725 92.2158H85.1455C85.9642 92.2158 86.429 91.2804 85.9326 90.6279L80.8127 83.9022C80.439 83.4098 79.8576 83.1211 79.2406 83.1211H85.6656C86.2846 83.1211 86.866 83.4098 87.2397 83.9022L92.3596 90.6279C92.854 91.2804 92.3912 92.2158 91.5725 92.2158Z",
    fill: "#FFFBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5722 92.2163H71.5955C70.9779 92.2163 70.3959 91.928 70.0218 91.4364L64.9023 84.7096C64.4068 84.0586 64.8711 83.122 65.689 83.122H85.6659C86.2833 83.122 86.8655 83.4105 87.2394 83.9019L92.3591 90.6287C92.8545 91.2797 92.3903 92.2163 91.5722 92.2163Z",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6252 92.2158H50.5509",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3138 87.2964H52.4622",
    stroke: "#005B99",
    strokeWidth: 2.96631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2041_50918",
    x1: 117.258,
    y1: 7.68432,
    x2: 4.1653,
    y2: -13.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0CCDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_50918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSellout);
export default __webpack_public_path__ + "static/media/empty-state-sellout.b368c1c8bbd43d70bbb25715c67002a4.svg";
export { ForwardRef as ReactComponent };